import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable ,map} from 'rxjs';

;
import {  finalize ,first,delay,take,tap} from 'rxjs/operators';
import { AccountService, AlertService } from '@app/_services';
import { environment } from '@environments/environment';
import { Signup, Package, orderType, Partner } from '@app/_models';
import { Product } from '@app/_models/orders/shared';
import * as _ from 'lodash';

const baseUrl = `${environment.apiUrl}/signup`;

@Injectable({ providedIn: 'root' })
export class SignupService {
  private signupSubject: BehaviorSubject<Signup>;
  public signup: Observable<Signup>;

  contactID: string;

  constructor(
    private router: Router,
    private http: HttpClient,
    private accountService: AccountService,
  ) {
    this.signupSubject = new BehaviorSubject<Signup>(null);
    this.signup = this.signupSubject.asObservable();
  }

  public get signupValue(): Signup {
    return this.signupSubject.value;
  }

  saveStart(signup: Signup, state: string): void {
    const stored = this.getSignup();

    Object.assign(stored, signup);

    stored.billToState = state;

    sessionStorage.setItem('signup', JSON.stringify(stored));
  }

  saveClientID(signup: Signup): void {
    const stored = this.getSignup();

    Object.assign(stored, signup);
    
    sessionStorage.setItem('signup', JSON.stringify(stored));
  }

  savePackage(signup: Signup): void {
    const stored = this.getSignup();

    Object.assign(stored, signup);

    sessionStorage.setItem('signup', JSON.stringify(stored));
  }

  saveCandidateDetails(signup: Signup): void {
    const stored = this.getSignup();

    Object.assign(stored, signup);

    sessionStorage.setItem('signup', JSON.stringify(stored));
  }

  saveFinalSignup(signup: Signup): Observable<any> {
    const stored = this.getSignup();

    Object.assign(stored, signup);

    sessionStorage.setItem('signup', JSON.stringify(stored));

    return this.http.post<any[]>(`${baseUrl}/sign-up`, signup);
  }

  getSignup(): Signup {
    const signup = new Signup();

    const stored = JSON.parse(sessionStorage.getItem('signup'));

    Object.assign(signup, stored);

    return signup;
  }

  getPackageTemplates(): Observable<Package[]> {
    return this.http.get<Package[]>(`${baseUrl}/get-packages`);
  }

  getPartnerPackages(tierID: number): Observable<Package[]> {
    return this.http.get<Package[]>(`${baseUrl}/get-partner-packages?tierID=${tierID}`);
  }

  getClientPackages(contactID: string): Observable<Package[]> {

    var id = contactID;
    return this.http.get<Package[]>(`${baseUrl}/get-client-packages?contactID=${contactID}`).pipe();
  }

  getPartnerClientPackages(contactID: string): Observable<Package[]> {

    var id = contactID;
    return this.http.get<Package[]>(`${baseUrl}/get-partner-client-packages?contactID=${contactID}`).pipe();
  }

  getLegalForm(legalFormID: string): Observable<any> {
    var formURL = `${baseUrl}/getlegalform?id=${legalFormID}`;
    return this.http.get(formURL, {responseType: "text"});
  }
  
   getClientSMB(): Observable<any>{

    this.contactID = this.accountService.accountValue.id;

   return this.http.get(`${baseUrl}/getClientSMB/?id=${this.contactID}`).pipe();
  }

  getPartner(partner: Partner): Observable<any>{
   var id = partner.partnerID;
   return this.http.get(`${baseUrl}/get-partner/?id=${id}`).pipe();
  }

  getPartnerByID(id: number): Observable<any>{
    return this.http.get(`${baseUrl}/get-partner/?id=${id}`).pipe();
   }

   getALaCarteProducts(clientID: number): Observable<Product[]>{
    return this.http.get<Product[]>(`${baseUrl}/alacarte-products/?clientID=${clientID}`).pipe();
   }

  savePayment(signup: Signup, accountId: string, profileId: string, authAgreement: string): void {
    const stored = this.getSignup();

    Object.assign(stored, signup);

    stored.ccnumber = signup.ccnumber.replace(/\d(?=\d{4})/g, '*');
    stored.ccaccountid = accountId;
    stored.ccprofileid = profileId;
    stored.ccauthagreement = authAgreement;
    stored.ccaddress = signup.ccaddress;
    stored.cccity = signup.cccity;
    stored.ccpostal = signup.ccpostal;
    stored.ccregion = signup.ccregion;
    stored.cccountry = signup.cccountry;
    stored.hasCompletedPayment = true;

    sessionStorage.setItem('signup', JSON.stringify(stored));
  }

  insertSMBClient(signup: Signup): Observable<any> {
    //signup.PSAN = "Max";
    return this.http.post<any>(`${baseUrl}/start`, signup);
  }

  insertPartner(signup: Signup): Observable<any> {
    return this.http.post<any>(`${baseUrl}/partner-start`, signup);
  }

  forwardPartner(signup: Signup): Observable<any> {
    return this.http.post<any>(`${baseUrl}/forward-partner`, signup);
  }
  
  forwardClient(signup: Signup): Observable<any> {
    return this.http.post<any>(`${baseUrl}/forward-client`, signup);
  }

  insertFreeBackgroundSMBClient(signup: Signup): Observable<any> {
    return this.http.post<any>(`${baseUrl}/free-background`, signup);
  }

  updateFirstTimeLogin(signup: Signup): Observable<any> {

    return this.http.post<any>(`${baseUrl}/UpdateFirstTimeLogin`, { 'email': signup.email, 'firsttimelogin': signup.firsttimelogin});
  }

  updateFirstTimeCredential(signup: Signup): Observable<any> {

    return this.http.post<any>(`${baseUrl}/UpdateFirstTimeCredential`, { 'email': signup.email, 'firsttimecredential': signup.firsttimecredential});
  }

  validateFreeBackgroundToken(token: string): Observable<any> {
    return this.http.post<any>(`${baseUrl}/free-background-auth`, { 'token': token });
  }
  sendPartnerEmail(id: number): Observable<any> {
    return this.http.get<any>(`${baseUrl}/partner-email/?id=${id}`).pipe();
  }

  handlePartnerToken(token: string): Observable<any> {
    return this.http.get<any>(`${baseUrl}/partner-token/?token=${token}`).pipe();
  }
}